module.exports = __webpack_public_path__ + "93697f548cb41309a680acb051208680.svg";